import * as errorTexts from '../../const/ErrorMessages/CustomerErrorMessages';
import {validateTaxValue} from './CompanyValidator';

export function validateCustomerType(customerType) {
    if (customerType === "PrivatePerson") {
        throw new Error(errorTexts.UNSELECTED_CUSTOMER_TYPE);
    }
}

export function validateCustomerCompanyName(companyName) {
    if (companyName === "") {
        throw new Error(errorTexts.UNSELECTED_COMPANY);
    }
}

export function validateCustomerTaxId(taxId) {
    validateTaxValue(taxId);
}

export function validateCustomerCompanyTaxId(companyTaxId) {
    if (companyTaxId === "") {
        throw new Error(errorTexts.UNSELECTED_COMPANY);
    }
    if (companyTaxId.length > 13) {
        throw new Error(errorTexts.INCORRECT_COMPANY_TAXID_MAX_LENGTH);
    }
}

export function validateCustomerName(customerName) {
    if (customerName === "") {
        throw new Error(errorTexts.EMPTY_CUSTOMER_NAME);
    }
    if (customerName.length > 500) {
        throw new Error(errorTexts.INCORRECT_CUSTOMER_NAME_MAX_LENGTH);
    }
}

export function valudateCustomerSurname(surname){
    if (surname === "") {
        throw new Error(errorTexts.EMPTY_CUSTOMER_SURNAME);
    }
}

export function validateCustomerEmail(customerEmail) {
    if (customerEmail === "") {
        throw new Error(errorTexts.EMPTY_CUSTOMER_EMAIL);
    }
    if (customerEmail.length > 127) {
        throw new Error(errorTexts.INCORRECT_CUSTOMER_EMAIL_MAX_LENGTH);
    }
    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(customerEmail)) {
        throw new Error(errorTexts.INCORRECT_EMAIL_FORMAT);
    }
}

export function validateCustomerCity(customerCity) {
    if (customerCity === "") {
        throw new Error(errorTexts.EMPTY_CUSTOMER_CITY);
    }
    if (customerCity.length > 40) {
        throw new Error(errorTexts.INCORRECT_CUSTOMER_CITY_MAX_LENGTH);
    }
}

export function validateCustomerCountry(customerCountry) {
    if (customerCountry === "") {
        throw new Error(errorTexts.EMPTY_CUSTOMER_COUNTRY);
    }
    if (customerCountry.length > 40) {
        throw new Error(errorTexts.INCORRECT_CUSTOMER_COUNTRY_MAX_LENGTH);
    }
}

export function validateCustomerPhone(customerPhone) {
    if (customerPhone === "") {
        throw new Error(errorTexts.EMPTY_CUSTOMER_PHONE);
    }
    if(customerPhone.length < 5) {
        throw new Error(errorTexts.INCORRECT_PHONE_MIN_LENGTH);
    }
    if(customerPhone.length > 20) {
        throw new Error(errorTexts.INCORRECT_PHONE_MAX_LENGTH);
    }
    if (!/^[0-9|\-|+|\s|(|)]{5,20}$/.test(customerPhone)) {
        throw new Error(errorTexts.INCORRECT_PHONE_FORMAT);
    }
}

// export function validatePhoneCode(phoneCode){
//     if (phoneCode === "") {
//         throw new Error(errorTexts.EMPTY_CUSTOMER_PHONE_CODE);
//     }

//     if (!/^[+]{1}[0-9]{1,}$/.test(phoneCode)) {
//         throw new Error(errorTexts.INCORRECT_PHONE_CODE);
//     }
// }

export function validateCustomerPostalCode(customerPostalCode) {
    if (customerPostalCode === "") {
        throw new Error(errorTexts.EMPTY_CUSTOMER_POSTAL_CODE);
    }
    if (!/^[0-9]{2}-[0-9]{3}$/.test(customerPostalCode)) {
        throw new Error(errorTexts.INCORRECT_POSTAL_CODE_FORMAT);
    }
}

export function validateCustomerStreet(customerStreet) {
    if (customerStreet === "") {
        throw new Error(errorTexts.EMPTY_CUSTOMER_STREET);
    }
    if (customerStreet.length > 255) {
        throw new Error(errorTexts.INCORRECT_CUSTOMER_STREET_MAX_LENGTH);
    }
}


// WEBPACK FOOTER //
// ./src/actions/Validators/CustomerValidator.js